import React from 'react';
import { Calendar } from 'primereact/calendar';
import './Filter.scss';


export const Filter = (props) => {
    return (

        <div className="p-grid">
            <div className="p-col-12">
                <div className="p-grid">

                    <div className="p-col-2 form-field-container">
                        <label className="lxRequiredField">De</label>
                        <Calendar
                            showIcon={true}
                            value={props.filterFields.initialDate}
                            showTime={false}
                            onChange={props.initialDateChangeHandler}
                            disabled={false}
                            name="initialDate"
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="p-col-2 form-field-container">
                        <label className="lxRequiredField">Até</label>
                        <Calendar
                            showIcon={true}
                            value={props.filterFields.finalDate}
                            showTime={false}
                            disabled={false}
                            onChange={props.finalDateChangeHandler}
                            name="finalDate"
                            dateFormat="dd/mm/yy" />
                    </div>
                    <div className="p-col-2 form-field-container">
                        <br />
                        <button
                            className="lognex-btn-highlighted"
                            style={{ width: "100%" }}
                            title="Filtrar"
                            onClick={props.applyFilter}>
                            Filtrar
                        </button>
                    </div>
                    <div className="p-col-2 form-field-container">
                        <br />
                        <button
                            className="lognex-btn-highlighted"
                            style={{ width: "100%" }}
                            title="Relatório"
                            onClick={props.downloadReport}>
                            Relatório
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
